import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLikeFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		stroke: "currentColor",
		strokeLinejoin: "round",
		strokeWidth: .857,
		d: "M8 4.603c3.652-3.703 9.911 3.175 0 8.73C-1.911 7.778 4.348.9 8 4.603Z"
	})
});
export default SvgLikeFilled;
